import { Box, Stack } from '@montugroup/design-system';
import { styled } from '@mui/material/styles';

import OrderProgressStepper from '@/components/order/order-history-card/OrderProgressStepper';
import { DELIVERY_OPTION, DELIVERY_OPTIONS } from '@montugroup/circuit-shared';
import { ClickAndCollectDetails } from './ClickAndCollectDetails';
import { ShippingAddressDetails } from './ShippingAddressDetails';

export type OrderStage =
  | 'cancelled'
  | 'orderPlaced'
  | 'readyForCollection'
  | 'shippedByPharmacy'
  | 'delivered'
  | 'collected';

export type PharmacyOrderDetailsProps = {
  pharmacy?: {
    name: string;
    address1: string;
    address2: string | null;
    city: string;
    state: string;
    zipCode: string;
  };
  stage: OrderStage;
  fullOrderCode: string;
  deliveryOption?: {
    name: (typeof DELIVERY_OPTIONS)[DELIVERY_OPTION]['name'];
  };
};

const Wrapper = styled(Box)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
}));

const OrderStepsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export function PharmacyOrderDetails(props: PharmacyOrderDetailsProps) {
  const { pharmacy, stage, fullOrderCode, deliveryOption } = props;
  const isClickAndCollect = deliveryOption?.name === DELIVERY_OPTIONS[DELIVERY_OPTION.ClickAndCollect].name;

  return (
    <Wrapper>
      <Stack direction="column" gap={2} sx={{ marginBottom: 6 }}>
        {isClickAndCollect && pharmacy && <ClickAndCollectDetails pharmacy={pharmacy} />}
        {!isClickAndCollect && <ShippingAddressDetails orderCode={fullOrderCode} />}
      </Stack>

      <OrderStepsContainer>
        <OrderProgressStepper stage={stage} isClickAndCollect={isClickAndCollect} />
      </OrderStepsContainer>
    </Wrapper>
  );
}

export default PharmacyOrderDetails;
